import Claimants from "./Claimants";

export default Claimants;